/**
 * Utility functions for theme-related calculations
 */

/**
 * Converts rem values to pixels
 * @param remValue - A string with rem unit (e.g., "1.5rem")
 * @param baseFontSize - Base font size in pixels (default: 16)
 * @returns Pixel value as string (e.g., "24px")
 */
export const remToPx = (remValue: string, baseFontSize: number = 16): string => {
  const numericValue = parseFloat(remValue.replace('rem', ''));
  if (isNaN(numericValue)) {
    throw new Error(`Invalid rem value: ${remValue}`);
  }
  return `${numericValue * baseFontSize}px`;
};

/**
 * Strips the unit from a CSS value and returns the numeric part
 * @param value - CSS value with unit (e.g., "24px", "1.5rem")
 * @returns Numeric value without unit
 */
export const stripUnit = (value: string): number => {
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) {
    throw new Error(`Invalid value: ${value}`);
  }
  return numericValue;
};
